import { render, staticRenderFns } from "./permissions-teams.vue?vue&type=template&id=50676d30&scoped=true"
import script from "./permissions-teams.vue?vue&type=script&lang=js"
export * from "./permissions-teams.vue?vue&type=script&lang=js"
import style0 from "./permissions-teams.vue?vue&type=style&index=0&id=50676d30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50676d30",
  null
  
)

export default component.exports